<template>
  <div :class="classes" @click="$emit('toggle-tab', tab)">
    <svg-vue :icon="icon" class="inline-block h-6 mr-2 stroke-current text-primary" style="fill: none" /> {{ label }}
  </div>
</template>

<script>
export default {
  name: 'ToggleTabButton',
  props: {
    tab: {
      type: String,
    },
    currentTab: {
      type: String,
    },
  },
  computed: {
    classes() {
      let classes = 'block py-3 px-6 border-b-2 cursor-pointer';

      if (this.isTheCurrentTab) {
        classes += ' text-primary-600 border-primary-600';
      }

      return classes;
    },
    label() {
      return this.tab.charAt(0).toUpperCase() + this.tab.slice(1);
    },
    isTheCurrentTab() {
      return this.tab === this.currentTab;
    },
    icon() {
      if (this.tab === 'story') {
        return 'clipboard-list';
      }
      if (this.tab === 'chat') {
        return 'chat';
      }

      return null;
    },
  },
  methods: {},
};
</script>
